/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuildingAmenityData { 
    businesses?: string;
    heatingSystem?: string;
    playground?: string;
    garageCount?: number;
    undergroundGarageCount?: number;
    flatCount?: number;
    convertedAttic?: BuildingAmenityData.ConvertedAtticEnum;
}
export namespace BuildingAmenityData {
    export type ConvertedAtticEnum = 'CONVERTED_ATTIC' | 'NO_CONVERTED_ATTIC' | 'PARTIALLY';
    export const ConvertedAtticEnum = {
        ConvertedAttic: 'CONVERTED_ATTIC' as ConvertedAtticEnum,
        NoConvertedAttic: 'NO_CONVERTED_ATTIC' as ConvertedAtticEnum,
        Partially: 'PARTIALLY' as ConvertedAtticEnum
    };
}


